import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Gamepad2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';

const SeatInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { acceptSeatInvite } = useAuth();
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    authAPI
      .previewSeatInvite(token)
      .then((data) => {
        if (!cancelled) setPreview(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.detail || 'This invite link is invalid or expired.');
        }
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await acceptSeatInvite(token, password);
      toast.success('Seat claimed. Welcome to the household.');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not claim this seat.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto gaming-card rounded-lg p-8 space-y-6">
      <div className="text-center">
        <Gamepad2 className="mx-auto h-12 w-12 text-white mb-3" />
        <h1 className="text-2xl font-bold text-white">Family seat invite</h1>
        <p className="text-white/70 text-sm mt-2">
          The household master sent this 72-hour link. Set your own password to join.
        </p>
      </div>
      {error ? (
        <p className="text-red-300 text-sm">{error}</p>
      ) : preview ? (
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-white">
            Seat {preview.family_seat}: <span className="font-semibold">{preview.username}</span>
          </p>
          <label className="block text-sm text-white">
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded-md text-black"
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <label className="block text-sm text-white">
            Confirm password
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded-md text-black"
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg disabled:opacity-50"
          >
            {loading ? 'Claiming seat…' : 'Claim this seat'}
          </button>
        </form>
      ) : (
        <p className="text-white/60 text-sm">Checking invite…</p>
      )}
    </div>
  );
};

export default SeatInvite;
